var ColorModel = require('./color-model');

module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id ? 'palettes/' + this.id : 'palettes');
  },

  parse: function (resource) {
    _.each(resource['data']['colors'], ColorModel.prototype.parse);
    return resource;
  }
});
